var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 994.4 350.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #5f5e5e;\n      }\n\n      .st1 {\n        fill: #e2e8e7;\n      }\n\n      .st2 {\n        fill: #dbe4e4;\n      }\n\n      .st3 {\n        fill: #e2e2e2;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n\n      .st5 {\n        fill: #ff1e00;\n      }\n\n      .st6 {\n        fill: #0abcaa;\n      }\n\n      .st7 {\n        fill: #dee6e6;\n      }\n\n      .st8 {\n        fill: #e0323f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.7,21.5c-.2-2.9-.2-5.9-.2-9.2.3,0,.7.1.7.3,0,2.9-.2,5.9-.5,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.4,10.6c-.4-1-.7-2.2-.9-3.6,1.7.6,1.6,2,.9,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258,1.6c-.5-.4-1-.9-1.5-1.6.5.4,1,.9,1.5,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259.4,3.1c-.4-.2-.9-.6-1.4-1.2.4.2.9.6,1.4,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260,4c-.3-.1-.4-.3-.6-.7.2,0,.5.3.6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.5,64.5c0-.2,0-.4.2-.7.3,0,.5.2.6.4-.2.1-.5.2-.8.3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 122.8,
    cy: 338,
    rx: 65.1,
    ry: 12.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.6,121.6c0,111.2-116.8,217.4-116.8,217.4,0,0-116.8-106.1-116.8-217.4,0-64.5,52.3-116.8,116.8-116.8s116.8,52.3,116.8,116.8h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 122.8,
    cy: 121.5,
    r: 101.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M122.8,27.2c-52.1,0-94.3,42.2-94.3,94.3s42.2,94.3,94.3,94.3,94.3-42.2,94.3-94.3S174.9,27.2,122.8,27.2ZM122.8,210.1c-48.9,0-88.6-39.6-88.6-88.6S73.9,33,122.8,33s88.6,39.7,88.6,88.6-39.7,88.6-88.6,88.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194.3,104.5c0,57.8-71.5,91.7-71.5,91.7,0,0-71.5-33.9-71.5-91.7s16.5-35.9,36.9-35.9,29.4,9.8,34.6,23.5c5.2-13.7,18.7-23.5,34.6-23.5s36.9,16.1,36.9,35.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.4,171.1h-.1c-.7,0-1.3-.6-1.5-1.4l-8.4-55-7.1,31.8c-.2.7-.8,1.2-1.5,1.2s-1.4-.4-1.6-1.1l-5.1-16.3-1.9,4.2c-.3.6-.8.9-1.4.9h-24.2c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6h23.1l3.2-7c.3-.6.9-1,1.5-.9.7,0,1.2.5,1.4,1.1l4.6,14.5,7.6-34.3c.2-.8.8-1.3,1.6-1.2.8,0,1.4.6,1.5,1.3l8.6,56.5,11.2-36.6c.2-.6.7-1.1,1.4-1.1.6,0,1.2.3,1.6.8l4.2,7.7h22.7c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6h-23.7c-.6,0-1.1-.3-1.4-.8l-2.8-5.2-12.1,39.6c-.2.7-.8,1.1-1.5,1.1h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.8,208.5l-14,35.6h-7.6l40.8-101.1h7.2l40.5,101.1h-7.6l-14.2-35.6h-45ZM333.4,202.3l-14.2-35.6c-2.7-6.8-4-11.1-5.5-16.1h-.3c-1.5,5.1-3.1,9.6-5.5,15.6l-14.4,36h40,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.9,240.6c-3.1,1.5-11.9,5.2-24.1,5.2-23,0-38.1-15.9-38.1-36.8s17.9-38.9,41-38.9,18.9,3,21.9,5.1l-2.7,6c-4.2-2.4-10.5-4.8-19.8-4.8-21.5,0-33,14.1-33,31.6s13.5,31.4,31.8,31.4,16.8-3,21-4.8l2.1,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.8,150.7c0,3.3-2.4,6.4-6.3,6.4s-5.9-3.1-5.9-6.4,2.7-6.4,6.1-6.4,6,3,6,6.4ZM447.1,244v-72h7.4v72h-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.8,136.6h7.4v107.4h-7.4v-107.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.6,144.3c9-1.2,19-2.2,30.3-2.2,21.5,0,37.8,5.9,47.2,16.2,8.4,9.1,12.2,19.9,12.2,33s-3.5,25.6-14,36.9c-9.8,10.4-26.8,16.8-49.5,16.8s-17.5-.1-26.2-.9v-99.8ZM557.9,237.9c4.8.8,12,.9,20.1.9,38.4,0,54.8-21.1,54.8-47.4.3-24.8-15.6-43.2-52.5-43.2s-17.1.9-22.3,1.9v87.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M728.9,207.1c0,27-21,38.7-38.7,38.7s-37-15.8-37-37.1,18-38.6,38.1-38.6,37.7,16.4,37.7,36.9h0ZM660.5,208.3c0,20.1,14.5,31.5,30.2,31.5s30.9-11.6,30.9-32.2-9.2-31.4-30.3-31.4-30.8,15.3-30.8,32.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M755.9,206.7h.3c2-2.2,5.4-5.9,8-8.2l28-26.4h9.3l-32.1,29.7,36.8,42.3h-9.2l-32.8-38.1-8.2,7.9v30.1h-7.3v-107.4h7.3v70.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M827.6,150.6v21.4h22.8v5.9h-22.8v46.1c0,8.9,2.7,15.6,11.5,15.6s7.3-.6,9.5-1.4l.9,5.7c-2.5,1.1-6.3,1.9-11.1,1.9s-10.3-1.8-13.3-5.4c-3.6-4.1-4.8-10.6-4.8-17.4v-45.1h-13.2v-5.9h13.2v-19.2l7.3-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M936.4,207.1c0,27-21,38.7-38.7,38.7s-37-15.8-37-37.1,18-38.6,38.1-38.6,37.7,16.4,37.7,36.9h0ZM868,208.3c0,20.1,14.5,31.5,30.2,31.5s30.9-11.6,30.9-32.2-9.2-31.4-30.3-31.4-30.8,15.3-30.8,32.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M956,195.3c0-7.8-.2-15.4-.6-23.2h6.8l.3,15.6h.5c3.6-10.1,11.4-17.4,22-17.4s2.4.1,3.5.4v6.8c-1.3-.3-2.5-.3-4.2-.3-10,0-17.7,8.4-20.1,20.9-.5,2.1-.8,4.6-.8,7.1v39h-7.3v-48.8h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo_grey.805486eb69fd4dc8dae6d6668eb4da4d.svg";
export { ForwardRef as ReactComponent };